import { css } from 'lit'

export const polarRouteSelectionStyles = [
    css`
        .polar-route-selection-background {
            background: linear-gradient(
                0deg,
                rgba(255, 255, 255, 0) -2.17%,
                #fff 84.00%
            );
            backdrop-filter: blur(2px);
            width: 100%;
            height: 100px;
            position: absolute;
            top: 100%;
        }

        .container {
            margin: 16px 24px;
        }
        .polar-route-selection {
            display: flex;
            flex-direction: row;
            gap: 24px;
            justify-content: space-between;
            align-items: center;
            margin-top: -10px;
        }

        .title {
            font-size: 18px;
            font-weight: 700;
            font-family: 'Maersk Text';
        }

        mc-input::part(label) {
            font-size: 14px;
            line-height: 24px;
            color: #545454;
        }

        .input {
            position: relative;
        }
        .select-current-position--btn {
            background: transparent;
            border: none;
            cursor: pointer;
        }

        .select-current-position {
            position: absolute;
            right: 5px;
            top: 23%;
            cursor: pointer;
        }

        mc-input::part(input) {
            font-family: 'Maersk Headline';
            width: 312px;
            font-size: 13px;
            padding-right: 40px;
        }

        .button-wrapper {
            display: flex;
            flex-direction: row;
            gap: 12px;
        }
    `,
]
